import styled from 'styled-components';

export const MapWrapper = styled.div`
  width: 100%;
  height: 472px;
  margin-top: 24px;
  background-color: ${({ theme }) => theme.colors.primaryText};
`;
